// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/scrollbars.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../editing/widgets/WidgetTags.module.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../scenarios/ScenarioLayers.module.css";
import ___CSS_LOADER_ICSS_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../packages/publishing/DrawerTabs.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_3___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Map Editor node's body (#662): the layers it is fed and the forms that
   edit them (LayerWorkbench), and its list of edits. Colours, type and radii
   are the tokens in styles/curioTokens.css; buttons and 22px controls are the
   Widgets tab's (WidgetTags.module.css); tags take the scenario rows' status
   tones (ScenarioLayers.module.css) and the count the drawer tabs' badge
   (DrawerTabs.module.css). */

.euKwskb7cFlCK0uOzMuL {
  --widget-h: 22px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
  padding: 8px 10px;
  overflow-y: auto;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-primary);
  background: var(--curio-card-bg);
}

/* The body takes the keys while it has the focus, with no ring around it. */
.euKwskb7cFlCK0uOzMuL:focus {
  outline: none;
}

.JZUJ4zMwUndzB0VJHj6D {
  font-size: var(--curio-font-size-xs);
  color: var(--curio-success-text);
}

.IgrGJTrX8XJFXUz3sref {
  margin: 0;
  color: var(--curio-danger-text);
  font-size: var(--curio-font-size-xs);
}

.nLADZ_gWTJnEM0Yfwqs7 {
  margin: 0;
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-xs);
}

/* The Widgets tab's buttons: a white one, a dark one for the main action and
   a red-text one for a removal, each with room for an icon. */
.lgoN7kEWeLrHja25npsZ {
  gap: 5px;
}

.g5xm3z7J0sm0zHGdbuyS {
  gap: 5px;
}

.l6CtbyySg6bg8r_8ysMi {
  gap: 5px;
}

/* A square button that shows only its icon. */
.kR4fiGWvq4lw_ox4S4KU {
  flex: 0 0 auto;
  width: var(--widget-h);
  padding: 0;
}

.LH4jMMX4N8skt2JJHPt5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

/* The way back: a link-like button, and Show only this layer beside it. */
.lKNIBkapxLEhGv_Z5jSh {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: var(--curio-text-secondary);
  cursor: pointer;
}

.lKNIBkapxLEhGv_Z5jSh:hover {
  color: var(--curio-text-primary);
}

.lKNIBkapxLEhGv_Z5jSh:focus-visible {
  border-radius: var(--curio-radius-sm);
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: 2px;
}

.dzMI6_vOCyK9tJAF6o7I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* The workbench: the layers, a layer's actions and the action's form. */
.Xbs0Jeuju6T10D5k5e0E,
.jVBw5I8CDFjO_SX2jRfA,
.RZsou7bZgT9dPONrATbQ {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.RZsou7bZgT9dPONrATbQ {
  gap: 6px;
}

.ojXvGetfhqc0S92n2uIi {
  font-size: var(--curio-font-size-md);
  font-weight: 600;
}

.zklyuwbqKEoKp_JnOmlQ {
  display: flex;
  align-items: center;
  gap: 6px;
}

.h9Qhu12kELVm616Byhls {
  justify-content: space-between;
  align-items: baseline;
}

.QcJtzQHLn2V4ElhTpfTP {
  line-height: 1.4;
}

.YaP7qGfEOMsb7mu9zogw,
.DQe4rDnHaTef2us_mQDp {
  font-size: var(--curio-font-size-xs);
  line-height: 1.4;
  color: var(--curio-text-secondary);
}

.HJSa07qwUqea01IbY77S {
  flex: none;
  color: var(--curio-text-secondary);
}

.D7iKl4htjESUJG4toOsd {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--curio-text-muted);
}

/* A layer, and an action on it: a card that fills on hover and takes the
   focus ring, so nothing moves under the pointer. */
.ZjWooL7bDfZV78PGEvMH,
.yX59fXMdWQ_8brWsKGJv {
  display: flex;
  flex-direction: column;
  gap: 2px;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.ZjWooL7bDfZV78PGEvMH:hover,
.yX59fXMdWQ_8brWsKGJv:hover:not(:disabled) {
  background: var(--curio-surface-muted);
}

.ZjWooL7bDfZV78PGEvMH:focus-visible,
.yX59fXMdWQ_8brWsKGJv:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: -1px;
}

.yX59fXMdWQ_8brWsKGJv:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.LU0l0Pz25ySfynl6rbXY {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  width: 100%;
}

.zvlfsMw3Q5cbZU6GVWvL,
.UqlwYuipCdFvrAXPOoMT {
  font-weight: 600;
}

.BWEAm2YFyPWEbEyb9kdS {
  overflow: hidden;
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-secondary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* A new layer's mark, and a picked feature's changed geometry or values. */
.HEJS0ouwTeNdhdGihb6u {
  font-weight: 400;
}

.WTmqzbS0UEXnGX8qcInk {
  font-weight: 400;
}

.Lw3dAdu1sdNvajRElIbQ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--curio-border);
}

.CE2EVfNMZCqHpc1i7CsG {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.T89eIGeth6kNMToCsbkq {
  font-size: var(--curio-font-size-xs);
  line-height: 1.4;
  color: var(--curio-text-secondary);
}

.T1rLFn17_VqKIoob9f2B {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-md);
}

.HWLYHj06ExFLiiHuCBEA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.YdP2RbvEA4Dk7Up8SyaJ {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* A choice of one, as the canvas bar's Canvas and Notebook switch, on a light
   surface: one bordered group, the option picked filled. */
.FDxpnmFfq4OL1BGZZpEj {
  display: inline-flex;
  align-self: flex-start;
  height: var(--widget-h);
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  overflow: hidden;
}

.Wo8ed71g3alDzP0oD7vT {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 0 8px;
  border: 0;
  background: var(--curio-card-bg);
  color: var(--curio-text-secondary);
  font: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.Wo8ed71g3alDzP0oD7vT + .Wo8ed71g3alDzP0oD7vT {
  border-left: 1px solid var(--curio-border-strong);
}

.Wo8ed71g3alDzP0oD7vT:hover {
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
}

/* An option that is off: never the one picked, and no hover. */
.Wo8ed71g3alDzP0oD7vT:disabled,
.Wo8ed71g3alDzP0oD7vT:disabled:hover {
  background: var(--curio-card-bg);
  color: var(--curio-text-secondary);
  opacity: 0.5;
  cursor: not-allowed;
}

.hc86S44CJS8pOaXWSr_s,
.hc86S44CJS8pOaXWSr_s:hover {
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
}

.Wo8ed71g3alDzP0oD7vT:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: -2px;
}

/* A field: its name, whether it is required and a hint, then its control. */
.P9_J2UEIYQHJuKwktyG1 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Ogm0fPPC4LJrFoi4dHJF {
  font-weight: 500;
}

.hi8_ugLyqcjnLhaAB9zG {
  color: var(--curio-danger-text);
  font-size: var(--curio-font-size-xs);
}

.cFVxKhxNLXxkC95uBL09 {
  display: flex;
  gap: 6px;
}

/* A picked feature's values: a name, its field and what it was. */
.sHZUq7TfaXYnGCRj4xaf {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 6px 8px;
  align-items: center;
}

.pZjUXAxwOaUgDdEK4cJ_ {
  overflow: hidden;
  color: var(--curio-text-secondary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sT0Gu_PSXdeHALD60Vud {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

/* A value changed and not applied yet. Two classes outweigh the widget
   theme's one on Material UI's field. */
.To1rdNtJWjimwRjIeo_g .MuiInputBase-root {
  background-color: var(--curio-warning-bg);
}

.To1rdNtJWjimwRjIeo_g .MuiOutlinedInput-notchedOutline {
  border-color: var(--curio-warning-text);
}

/* A note on a field: what it was, or the values a building's parts hold. It
   sits under the field, in the value column, so the field keeps the column's
   whole width, as a field without a note does, and a long note wraps. */
.PwocHMS0Siy9QGojLFxq {
  grid-column: 2;
  font-size: var(--curio-font-size-xs);
  line-height: 1.4;
  color: var(--curio-text-secondary);
  overflow-wrap: anywhere;
}

/* A rule's conditions, then what it changes. */
.CI8UgeMhjN8mgVo0kF_u {
  display: grid;
  grid-template-columns: 28px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1.2fr) var(--widget-h);
  gap: 6px;
  align-items: center;
}

.FIKhc5w4tFAO7_2fR3Rc {
  font-weight: 600;
}

/* A new layer's properties, a row each. */
.eN8ay0JGpeDJBXNoOX2l {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr) minmax(0, 1.2fr) 56px var(--widget-h);
  gap: 6px;
  align-items: center;
}

/* The list of edits, by layer, each with what it does and Undo and Redo in
   its head. Its rows are hairlines, as the Widgets tab's. */
.OfCENy4ljwGNYAmPll6v {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid var(--curio-border);
}

.dxRl6pI4mJ8MNwvpdb8I {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* The list's name, and each layer's above its edits. */
.gcilligBR7gBBVOu9tZM {
  font-weight: 600;
}

.b1hpDsUCzNh3wuaUCZyo {
}

.pdrYbngY8YGxbi0lR8Nw {
  display: inline-flex;
  gap: 4px;
  margin-left: auto;
}

.CH2_das7AKCXNv9aqBex {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 240px;
  overflow-y: auto;
  user-select: text;
}

.rr6ca3ABeNXBuxtKjgD9 {
  margin: 0;
  padding: 0;
  list-style: none;
}

.r37ssTUkO8moCUNvn3kA {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  border-bottom: 1px solid var(--curio-border);
}

.r37ssTUkO8moCUNvn3kA:last-child {
  border-bottom: 0;
}

.AYdP0ERz36ndsSFehvCO {
  flex: 1;
  min-width: 0;
  font-size: var(--curio-font-size-xs);
  line-height: 1.4;
  overflow-wrap: anywhere;
}

/* An entry switched off: kept in the list, skipped by the run. */
.rG7vj2jrwflqntULpm4l .AYdP0ERz36ndsSFehvCO {
  color: var(--curio-text-secondary);
  text-decoration: line-through;
}

.ONpevvyRqUoMpw9H4O6g {
  flex: 0 0 auto;
}

/* The foot of the list: whether the nodes below have the edits, and Commit
   edits to run them with them; amber while they do not, green once they do. */
.l72DKXMYe41tCBXihXYW {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px 8px;
  padding: 6px 8px;
  border-radius: var(--curio-radius-md);
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-xs);
}

.l72DKXMYe41tCBXihXYW[data-commit-state="stale"] {
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}

.l72DKXMYe41tCBXihXYW[data-commit-state="done"] {
  justify-content: flex-start;
  background: var(--curio-success-bg);
  color: var(--curio-success-text);
  font-weight: 600;
}

.MrYW6pRUneJ_j9VvB54w {
  flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/editFeatures/EditFeatures.module.css"],"names":[],"mappings":"AAAA;;;;;6BAK6B;;AAE7B;EAEE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;8DAC8D;AAC9D;EAEE,QAAQ;AACV;;AAEA;EAEE,QAAQ;AACV;;AAEA;EAEE,QAAQ;AACV;;AAEA,8CAA8C;AAC9C;EAEE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA,0EAA0E;AAC1E;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,wEAAwE;AACxE;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;oDACoD;AACpD;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EAEE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;2DAC2D;AAC3D;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,+DAA+D;AAC/D;;EAEE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;wCACwC;AACxC;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;wEAEwE;AACxE;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,4FAA4F;EAC5F,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8FAA8F;EAC9F,QAAQ;EACR,mBAAmB;AACrB;;AAEA;4DAC4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EAEE,cAAc;AAChB;;AAEA;8EAC8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,sCAAsC;EACtC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* The Map Editor node's body (#662): the layers it is fed and the forms that\n   edit them (LayerWorkbench), and its list of edits. Colours, type and radii\n   are the tokens in styles/curioTokens.css; buttons and 22px controls are the\n   Widgets tab's (WidgetTags.module.css); tags take the scenario rows' status\n   tones (ScenarioLayers.module.css) and the count the drawer tabs' badge\n   (DrawerTabs.module.css). */\n\n.body {\n  composes: thinScrollbar from \"../../styles/scrollbars.module.css\";\n  --widget-h: 22px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  overflow-y: auto;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-primary);\n  background: var(--curio-card-bg);\n}\n\n/* The body takes the keys while it has the focus, with no ring around it. */\n.body:focus {\n  outline: none;\n}\n\n.connected {\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-success-text);\n}\n\n.problem {\n  margin: 0;\n  color: var(--curio-danger-text);\n  font-size: var(--curio-font-size-xs);\n}\n\n.note {\n  margin: 0;\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-xs);\n}\n\n/* The Widgets tab's buttons: a white one, a dark one for the main action and\n   a red-text one for a removal, each with room for an icon. */\n.button {\n  composes: button from \"../editing/widgets/WidgetTags.module.css\";\n  gap: 5px;\n}\n\n.primary {\n  composes: primary from \"../editing/widgets/WidgetTags.module.css\";\n  gap: 5px;\n}\n\n.danger {\n  composes: danger from \"../editing/widgets/WidgetTags.module.css\";\n  gap: 5px;\n}\n\n/* A square button that shows only its icon. */\n.iconButton {\n  composes: danger from \"../editing/widgets/WidgetTags.module.css\";\n  flex: 0 0 auto;\n  width: var(--widget-h);\n  padding: 0;\n}\n\n.formButtons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n/* The way back: a link-like button, and Show only this layer beside it. */\n.back {\n  align-self: flex-start;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: var(--curio-text-secondary);\n  cursor: pointer;\n}\n\n.back:hover {\n  color: var(--curio-text-primary);\n}\n\n.back:focus-visible {\n  border-radius: var(--curio-radius-sm);\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: 2px;\n}\n\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/* The workbench: the layers, a layer's actions and the action's form. */\n.workbench,\n.form,\n.group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.group {\n  gap: 6px;\n}\n\n.title {\n  font-size: var(--curio-font-size-md);\n  font-weight: 600;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.spread {\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.lead {\n  line-height: 1.4;\n}\n\n.hint,\n.meta {\n  font-size: var(--curio-font-size-xs);\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n}\n\n.icon {\n  flex: none;\n  color: var(--curio-text-secondary);\n}\n\n.groupLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--curio-text-muted);\n}\n\n/* A layer, and an action on it: a card that fills on hover and takes the\n   focus ring, so nothing moves under the pointer. */\n.layerCard,\n.actionCard {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  box-sizing: border-box;\n  padding: 6px 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.layerCard:hover,\n.actionCard:hover:not(:disabled) {\n  background: var(--curio-surface-muted);\n}\n\n.layerCard:focus-visible,\n.actionCard:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: -1px;\n}\n\n.actionCard:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cardTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n  width: 100%;\n}\n\n.cardName,\n.actionTitle {\n  font-weight: 600;\n}\n\n.props {\n  overflow: hidden;\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-secondary);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* A new layer's mark, and a picked feature's changed geometry or values. */\n.badge {\n  composes: status from \"../scenarios/ScenarioLayers.module.css\";\n  font-weight: 400;\n}\n\n.changed {\n  composes: status from \"../scenarios/ScenarioLayers.module.css\";\n  font-weight: 400;\n}\n\n.footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--curio-border);\n}\n\n.actionGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.actionText {\n  font-size: var(--curio-font-size-xs);\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-md);\n}\n\n.sectionHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n}\n\n.toolRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* A choice of one, as the canvas bar's Canvas and Notebook switch, on a light\n   surface: one bordered group, the option picked filled. */\n.modes {\n  display: inline-flex;\n  align-self: flex-start;\n  height: var(--widget-h);\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  overflow: hidden;\n}\n\n.mode {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0;\n  padding: 0 8px;\n  border: 0;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-secondary);\n  font: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.mode + .mode {\n  border-left: 1px solid var(--curio-border-strong);\n}\n\n.mode:hover {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n}\n\n/* An option that is off: never the one picked, and no hover. */\n.mode:disabled,\n.mode:disabled:hover {\n  background: var(--curio-card-bg);\n  color: var(--curio-text-secondary);\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modeChecked,\n.modeChecked:hover {\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n}\n\n.mode:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: -2px;\n}\n\n/* A field: its name, whether it is required and a hint, then its control. */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fieldName {\n  font-weight: 500;\n}\n\n.required {\n  color: var(--curio-danger-text);\n  font-size: var(--curio-font-size-xs);\n}\n\n.choiceRow {\n  display: flex;\n  gap: 6px;\n}\n\n/* A picked feature's values: a name, its field and what it was. */\n.grid {\n  display: grid;\n  grid-template-columns: 96px minmax(0, 1fr);\n  gap: 6px 8px;\n  align-items: center;\n}\n\n.gridLabel {\n  overflow: hidden;\n  color: var(--curio-text-secondary);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gridValue {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n/* A value changed and not applied yet. Two classes outweigh the widget\n   theme's one on Material UI's field. */\n.dirty :global(.MuiInputBase-root) {\n  background-color: var(--curio-warning-bg);\n}\n\n.dirty :global(.MuiOutlinedInput-notchedOutline) {\n  border-color: var(--curio-warning-text);\n}\n\n/* A note on a field: what it was, or the values a building's parts hold. It\n   sits under the field, in the value column, so the field keeps the column's\n   whole width, as a field without a note does, and a long note wraps. */\n.fieldNote {\n  grid-column: 2;\n  font-size: var(--curio-font-size-xs);\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n  overflow-wrap: anywhere;\n}\n\n/* A rule's conditions, then what it changes. */\n.ruleRow {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1.2fr) var(--widget-h);\n  gap: 6px;\n  align-items: center;\n}\n\n.matchCount {\n  font-weight: 600;\n}\n\n/* A new layer's properties, a row each. */\n.propGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr) minmax(0, 1.2fr) 56px var(--widget-h);\n  gap: 6px;\n  align-items: center;\n}\n\n/* The list of edits, by layer, each with what it does and Undo and Redo in\n   its head. Its rows are hairlines, as the Widgets tab's. */\n.log {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 8px;\n  border-top: 1px solid var(--curio-border);\n}\n\n.logHead {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* The list's name, and each layer's above its edits. */\n.logTitle {\n  font-weight: 600;\n}\n\n.logCount {\n  composes: tabBadge tabBadgeDark from \"../packages/publishing/DrawerTabs.module.css\";\n}\n\n.history {\n  display: inline-flex;\n  gap: 4px;\n  margin-left: auto;\n}\n\n.logBody {\n  composes: thinScrollbar from \"../../styles/scrollbars.module.css\";\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 240px;\n  overflow-y: auto;\n  user-select: text;\n}\n\n.logList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.logRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 0;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.logRow:last-child {\n  border-bottom: 0;\n}\n\n.logText {\n  flex: 1;\n  min-width: 0;\n  font-size: var(--curio-font-size-xs);\n  line-height: 1.4;\n  overflow-wrap: anywhere;\n}\n\n/* An entry switched off: kept in the list, skipped by the run. */\n.logOff .logText {\n  color: var(--curio-text-secondary);\n  text-decoration: line-through;\n}\n\n.opTag {\n  composes: status from \"../scenarios/ScenarioLayers.module.css\";\n  flex: 0 0 auto;\n}\n\n/* The foot of the list: whether the nodes below have the edits, and Commit\n   edits to run them with them; amber while they do not, green once they do. */\n.commit {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px 8px;\n  padding: 6px 8px;\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-xs);\n}\n\n.commit[data-commit-state=\"stale\"] {\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n\n.commit[data-commit-state=\"done\"] {\n  justify-content: flex-start;\n  background: var(--curio-success-bg);\n  color: var(--curio-success-text);\n  font-weight: 600;\n}\n\n.commitText {\n  flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `euKwskb7cFlCK0uOzMuL ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"connected": `JZUJ4zMwUndzB0VJHj6D`,
	"problem": `IgrGJTrX8XJFXUz3sref`,
	"note": `nLADZ_gWTJnEM0Yfwqs7`,
	"button": `lgoN7kEWeLrHja25npsZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"primary": `g5xm3z7J0sm0zHGdbuyS ${___CSS_LOADER_ICSS_IMPORT_1___.locals["primary"]}`,
	"danger": `l6CtbyySg6bg8r_8ysMi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["danger"]}`,
	"iconButton": `kR4fiGWvq4lw_ox4S4KU ${___CSS_LOADER_ICSS_IMPORT_1___.locals["danger"]}`,
	"formButtons": `LH4jMMX4N8skt2JJHPt5`,
	"back": `lKNIBkapxLEhGv_Z5jSh`,
	"backRow": `dzMI6_vOCyK9tJAF6o7I`,
	"workbench": `Xbs0Jeuju6T10D5k5e0E`,
	"form": `jVBw5I8CDFjO_SX2jRfA`,
	"group": `RZsou7bZgT9dPONrATbQ`,
	"title": `ojXvGetfhqc0S92n2uIi`,
	"titleRow": `zklyuwbqKEoKp_JnOmlQ`,
	"spread": `h9Qhu12kELVm616Byhls`,
	"lead": `QcJtzQHLn2V4ElhTpfTP`,
	"hint": `YaP7qGfEOMsb7mu9zogw`,
	"meta": `DQe4rDnHaTef2us_mQDp`,
	"icon": `HJSa07qwUqea01IbY77S`,
	"groupLabel": `D7iKl4htjESUJG4toOsd`,
	"layerCard": `ZjWooL7bDfZV78PGEvMH`,
	"actionCard": `yX59fXMdWQ_8brWsKGJv`,
	"cardTop": `LU0l0Pz25ySfynl6rbXY`,
	"cardName": `zvlfsMw3Q5cbZU6GVWvL`,
	"actionTitle": `UqlwYuipCdFvrAXPOoMT`,
	"props": `BWEAm2YFyPWEbEyb9kdS`,
	"badge": `HEJS0ouwTeNdhdGihb6u ${___CSS_LOADER_ICSS_IMPORT_2___.locals["status"]}`,
	"changed": `WTmqzbS0UEXnGX8qcInk ${___CSS_LOADER_ICSS_IMPORT_2___.locals["status"]}`,
	"footer": `Lw3dAdu1sdNvajRElIbQ`,
	"actionGrid": `CE2EVfNMZCqHpc1i7CsG`,
	"actionText": `T89eIGeth6kNMToCsbkq`,
	"section": `T1rLFn17_VqKIoob9f2B`,
	"sectionHead": `HWLYHj06ExFLiiHuCBEA`,
	"toolRow": `YdP2RbvEA4Dk7Up8SyaJ`,
	"modes": `FDxpnmFfq4OL1BGZZpEj`,
	"mode": `Wo8ed71g3alDzP0oD7vT`,
	"modeChecked": `hc86S44CJS8pOaXWSr_s`,
	"field": `P9_J2UEIYQHJuKwktyG1`,
	"fieldName": `Ogm0fPPC4LJrFoi4dHJF`,
	"required": `hi8_ugLyqcjnLhaAB9zG`,
	"choiceRow": `cFVxKhxNLXxkC95uBL09`,
	"grid": `sHZUq7TfaXYnGCRj4xaf`,
	"gridLabel": `pZjUXAxwOaUgDdEK4cJ_`,
	"gridValue": `sT0Gu_PSXdeHALD60Vud`,
	"dirty": `To1rdNtJWjimwRjIeo_g`,
	"fieldNote": `PwocHMS0Siy9QGojLFxq`,
	"ruleRow": `CI8UgeMhjN8mgVo0kF_u`,
	"matchCount": `FIKhc5w4tFAO7_2fR3Rc`,
	"propGrid": `eN8ay0JGpeDJBXNoOX2l`,
	"log": `OfCENy4ljwGNYAmPll6v`,
	"logHead": `dxRl6pI4mJ8MNwvpdb8I`,
	"logTitle": `gcilligBR7gBBVOu9tZM`,
	"logCount": `b1hpDsUCzNh3wuaUCZyo ${___CSS_LOADER_ICSS_IMPORT_3___.locals["tabBadge"]} ${___CSS_LOADER_ICSS_IMPORT_3___.locals["tabBadgeDark"]}`,
	"history": `pdrYbngY8YGxbi0lR8Nw`,
	"logBody": `CH2_das7AKCXNv9aqBex ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"logList": `rr6ca3ABeNXBuxtKjgD9`,
	"logRow": `r37ssTUkO8moCUNvn3kA`,
	"logText": `AYdP0ERz36ndsSFehvCO`,
	"logOff": `rG7vj2jrwflqntULpm4l`,
	"opTag": `ONpevvyRqUoMpw9H4O6g ${___CSS_LOADER_ICSS_IMPORT_2___.locals["status"]}`,
	"commit": `l72DKXMYe41tCBXihXYW`,
	"commitText": `MrYW6pRUneJ_j9VvB54w`
};
export default ___CSS_LOADER_EXPORT___;
